<template>
  <div class="bg-white mt-10 p-md-5">
    <div class="container">
      <div class="card">
        <div class="card-header">
          <h3 class="text-center mb-5">
            Join Us <span class="text-light">|</span> הצטרפו אלינו
          </h3>
        </div>
        <div v-if="!created">
          <div class="alert alert-warning text-center rtl">
            יש למלא את כל השדות באנגלית בלבד
          </div>
          <form class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="name"
                      class="form-control form-control-flush"
                      v-model="form.name"
                      name="organization"
                      placeholder="Organization Name"
                      :class="[
                        $v.form.name.$invalid ? 'is-invalid' : 'is-valid',
                      ]"
                      required
                    />
                    <label for="name">Organization name</label>
                    <label for="name" class="hebrew-label">שם העמותה</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="number"
                      class="form-control form-control-flush"
                      v-model="form.number"
                      name="number"
                      placeholder="Organization Number"
                      required
                      :class="[
                        $v.form.number.$invalid ? 'is-invalid' : 'is-valid',
                      ]"
                    />
                    <label for="name">Organization number</label>
                    <label for="name" class="hebrew-label">מספר עמותה</label>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <!-- <label
                      for="name"
                      v-bind:style="
                        $v.form.organization_countries.$invalid
                          ? 'color: red;'
                          : 'color: green;'
                      "
                      >Select which Foundation you wish to join:
                    </label>
                    <input
                      class="form-check-input"
                      name=""
                      hidden
                      value="Neeman USA"
                      v-model="form.organization_countries"
                    /> -->
                    <!-- <label
                      class="hebrew-label float-right"
                      for="name"
                      v-bind:style="
                        $v.form.organization_countries.$invalid
                          ? 'color: red;'
                          : 'color: green;'
                      "
                      >בחר לאיזו קרן ברצונך להירשם
                    </label> -->
                    <!-- <div
                      class="form-check"
                      v-for="country in organization_countries"
                      :key="country"
                    >
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name=""
                          :value="country"
                          v-model="form.organization_countries"
                        />
                        {{ country }}
                      </label>
                    </div> -->
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="f_name"
                      class="form-control form-control-flush"
                      v-model="form.f_name"
                      name="f_name"
                      placeholder="Your First Name"
                      required
                      :class="[
                        $v.form.f_name.$invalid ? 'is-invalid' : 'is-valid',
                      ]"
                    />
                    <label for="name">First name</label>
                    <label for="name" class="hebrew-label">שם פרטי</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="l_name"
                      class="form-control form-control-flush"
                      v-model="form.l_name"
                      name="l_name"
                      placeholder="Your Last Name"
                      required
                      :class="[
                        $v.form.l_name.$invalid ? 'is-invalid' : 'is-valid',
                      ]"
                    />
                    <label for="name">Last name</label>
                    <label for="name" class="hebrew-label">שם משפחה</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="address"
                      class="form-control form-control-flush"
                      v-model="form.address"
                      name="l_name"
                      placeholder="Your address"
                      required
                      :class="[
                        $v.form.address.$invalid ? 'is-invalid' : 'is-valid',
                      ]"
                    />
                    <label for="name">Organization Address</label>
                    <label for="name" class="hebrew-label">כתובת עמותה</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <select
                      class="form-control form-control-flush"
                      id="country"
                      v-model="form.country"
                      required
                      :class="[
                        $v.form.country.$invalid ? 'is-invalid' : 'is-valid',
                      ]"
                    >
                      <option value disabled selected>Select country</option>
                      <option
                        v-bind:value="country.id"
                        v-for="country in countries"
                        v-bind:key="country.id"
                      >
                        {{ country.name }}
                      </option>
                    </select>
                    <label for="name">Organization country</label>
                    <label for="name" class="hebrew-label">ארץ עמותה</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input
                      type="email"
                      class="form-control form-control-flush"
                      v-model="form.email"
                      name="email"
                      placeholder="Your Email"
                      required
                      :class="[
                        $v.form.email.$invalid ? 'is-invalid' : 'is-valid',
                      ]"
                    />
                    <label for="name">Email</label>
                    <label for="name" class="hebrew-label">אימייל</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input
                      type="password"
                      v-model="form.password"
                      class="form-control form-control-flush"
                      id="exampleInputPassword1"
                      placeholder="Enter Password"
                      autocomplete="off"
                      required
                      :class="[
                        $v.form.password.$invalid ? 'is-invalid' : 'is-valid',
                      ]"
                    />
                    <label for="exampleInputPassword1">Choose Password</label>
                    <label for="name" class="hebrew-label">בחר סיסמא</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="tel"
                      class="form-control form-control-flush"
                      v-model="form.tel"
                      name="tel"
                      placeholder="Your Phone number"
                      required
                      :class="[
                        $v.form.tel.$invalid ? 'is-invalid' : 'is-valid',
                      ]"
                    />
                    <label for="name">Phone number</label>
                    <label for="name" class="hebrew-label">טלפון</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="authorized_signatory"
                      class="form-control form-control-flush"
                      v-model="form.authorized_signatory"
                      name="authorized_signatory"
                      placeholder="Name of authorized signatory"
                      required
                      :class="[
                        $v.form.authorized_signatory.$invalid
                          ? 'is-invalid'
                          : 'is-valid',
                      ]"
                    />
                    <label for="name">Authorized signatory name</label>
                    <label for="name" class="hebrew-label"
                      >שם מורשה חתימה</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div v-if="error" class="alert alert-danger">{{ error }}</div>
              <div class="text-center mb-5 mt-5">
                <button
                  :disabled="$v.$invalid"
                  type="submit"
                  v-bind:class="[
                    $v.$invalid ? 'btn btn-primary' : 'btn btn-success',
                  ]"
                  @click.prevent="sendForm"
                >
                  <div v-if="!processing">
                    <i class="fad fa-shield-check"></i> Submit Registration
                  </div>
                  <div v-else>
                    <span class="spinner-border text-primary" role="status">
                      <span class="sr-only">Processing...</span>
                    </span>
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="text-center mb-5" v-else>
          Your account has been created. Please check Your email for a
          verification link.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email, helpers } from "vuelidate/lib/validators";
const alphaNumAndDotValidator = helpers.regex(
  "alphaNumAndDot",
  /^[a-z\d.\s]*$/i
);

export default {
  name: "Join",
  metaInfo: {
    title: "Join Ne'eman Foundation",
  },

  data() {
    return {
      error: "",
      countries: [],
      created: false,
      processing: false,
      organization_countries: ["Neeman USA", "Neeman Canada"],
      form: {
        name: "",
        number: "",
        f_name: "",
        l_name: "",
        email: "",
        country: "",
        address: "",
        tel: "",
        authorized_signatory: "",
        organization_countries: ["Neeman USA"],
        password: "",
      },
    };
  },
  validations: {
    form: {
      name: { required, alphaNumAndDotValidator },
      number: { required },
      f_name: { required, alphaNumAndDotValidator },
      l_name: { required, alphaNumAndDotValidator },
      country: { required, alphaNumAndDotValidator },
      password: { required },
      tel: { required },
      authorized_signatory: { required },
      address: { required, alphaNumAndDotValidator },
      organization_countries: { required },
      email: { required, email },
    },
  },
  mounted() {
    let self = this;
    this.axios
      .get(window.API_URL + "countries")
      .then(function (response) {
        self.countries = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    async sendForm() {
      this.processing = true;
      this.error = "";
      let self = this;
      await this.$recaptchaLoaded();
      this.form.token = await this.$recaptcha("social");
      if (!self.$v.$invalid) {
        this.axios
          .post(window.API_URL + "register", this.form)
          .then(function (response) {
            if (response.data.status && response.data.status == "success") {
              self.created = true;
              self.processing = false;
            }
            if (response.data.status && response.data.status == "error")
              self.error = response.data.message;
            self.processing = false;
          })
          .catch(function (error) {
            console.log(error);
            self.processing = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.form-label-group > label,
label {
  color: #627fad;
}
.hebrew-label {
  text-align: right;
  font-size: 16px;
}
.form-label-group > label,
.form-control {
  padding: 0.8125rem 0;
}
.rtl,
.hebrew-label {
  direction: rtl;
}
</style>